module.exports = __webpack_public_path__ + "media/src/website/images/locations/tegernsee/tegernsee_05-22eec420ce1a2bdc8ae22d00c33d476f.jpg";